import { API_TYPES } from "@src/appV2/api";
import z from "zod";

import { PLACEMENT_CANDIDATE_BAN_ACTION } from "../../PlacementCandidate/types";
import { DISPUTE_REASON } from "./createBanDispute.schema";

const placementCandidateBanSchema = z.object({
  type: z.literal(API_TYPES.placementCandidateBan),
  id: z.string(),
  attributes: z
    .object({
      reason: z.string().min(1),
      startsAt: z.string().datetime(),
      expiresAt: z.string().datetime().optional(),
      revokedAt: z.string().datetime().optional(),
      createdAt: z.string().datetime(),
      updatedAt: z.string().datetime(),
      action: z.nativeEnum(PLACEMENT_CANDIDATE_BAN_ACTION).optional(),
      dispute: z
        .object({
          reason: z.nativeEnum(DISPUTE_REASON),
          description: z.string(),
        })
        .optional(),
    })
    .strict(),
  relationships: z.object({
    placementCandidate: z.object({
      data: z.object({
        type: z.literal(API_TYPES.placementCandidate),
        id: z.string(),
      }),
    }),
    worker: z.object({
      data: z.object({
        type: z.literal(API_TYPES.worker),
        id: z.string(),
      }),
    }),
    interview: z
      .object({
        data: z.object({
          type: z.literal(API_TYPES.interview),
          id: z.string(),
        }),
      })
      .optional(),
  }),
});

const includedResourcesSchema = z.array(
  z.union([
    z.object({
      type: z.literal(API_TYPES.worker),
      id: z.string(),
      attributes: z.object({
        name: z.string(),
        email: z.string(),
      }),
    }),
    z.object({
      type: z.literal(API_TYPES.interview),
      id: z.string(),
      attributes: z.object({
        start: z.string().datetime(),
      }),
      relationships: z.object({
        workplace: z.object({
          data: z.object({
            type: z.literal(API_TYPES.workplace),
            id: z.string(),
          }),
        }),
      }),
    }),
    z.object({
      type: z.literal(API_TYPES.workplace),
      id: z.string(),
      attributes: z.object({
        name: z.string(),
      }),
    }),
  ])
);

export const placementCandidateBanResponseSchema = z.object({
  data: placementCandidateBanSchema,
  included: includedResourcesSchema,
});

export type PlacementCandidateBanResponse = z.infer<typeof placementCandidateBanResponseSchema>;
